import { watch } from 'vue'

import { SubParticipantsPatchPayload } from '@collector/sportsapi-client'
import {
  BaseballIncidentId,
  BaseballSubParticipantStatId,
  CommonEventDetailId,
  SubParticipantPosition,
} from '@collector/sportsapi-client-legacy'
import { sportsApiClient } from '@desktop/globalState/sportsApiClient'
import {
  useEventDetails,
  useIncidents,
  useSubParticipants,
} from '@desktop/views/Relation/composables'

export function useOnFirstInningStarted(): void {
  const { incidentsUpdate } = useIncidents()
  const { homeSubParticipants, awaySubParticipants } = useSubParticipants()
  const { getEventDetailValue } = useEventDetails()

  // init
  watch(incidentsUpdate, async (newVal) => {
    for (const incidentUpdate of newVal) {
      const { data: incident } = incidentUpdate

      if (
        incident.incident_id === BaseballIncidentId.FirstInningStarted &&
        incident.action !== 'delete' &&
        getEventDetailValue(CommonEventDetailId.HasLineups) === 'yes'
      ) {
        const payload: SubParticipantsPatchPayload[] = [
          ...homeSubParticipants.value,
          ...awaySubParticipants.value,
        ]
          .filter((sp) =>
            [
              SubParticipantPosition.Batter,
              SubParticipantPosition.Pitcher,
            ].includes(sp.position),
          )
          .map((sp) => ({
            id: sp.id,
            lineup_id: sp.lineup_id,
            short_name: sp.short_name,
            team_id: sp.team_id,
            stats: [
              {
                id: BaseballSubParticipantStatId.GameStarted,
                value: '1',
              },
            ],
          }))

        await sportsApiClient.Events.SubParticipants.patch(
          incident.event_id,
          payload,
          false,
        )

        break
      }
    }
  })
}
